import classes from "./Tabs.module.scss";
import { className } from "utils/strings";
import { useCallback } from "react";

type TabKey = string;

export interface ITab {
  label: string;
  value: TabKey;
}

interface IProps {
  value: TabKey;
  list: ITab[];
  onChange: (key: TabKey) => void;
}

export const Tabs = (props: IProps) => {
  const { list, onChange, value } = props;

  const handleClick = useCallback((key: TabKey) => () => {
    onChange(key);
  }, [onChange]);

  const tabs = list.map(tab => {
    return (
      <button
        key={tab.value}
        className={className({
          [classes.tab]: true,
          [classes.active]: tab.value === value
        })}
        onClick={handleClick(tab.value)}
      >
        {tab.label}
      </button>
    );
  });

  return (
    <div className={classes.tabs}>
      {tabs}
    </div>
  );
};
